<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- customer id -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="客戶："
                  label-for="id"
                  label-cols-md="3"
                  class="required"
                >
                  <div class="">
                    {{
                      newCustomerData.user_number
                        ? newCustomerData.user_number
                        : "系統自動生成"
                    }}
                  </div>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer name cn -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name_cn"
                >
                <!-- label="單據抬頭：" -->
                  <b-form-group
                    label="單據抬頭："
                    label-for="c_name_cn"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="c_name_cn"
                      v-model="newCustomerData.name_cn"
                      placeholder="輸入單據抬頭"
                      :state="getValidationState(validationContext)"
                      @blur="checkUserNameCn"
                    />

                    <label v-if="errorNameCnMessage && newCustomerData.name_cn" class="text-danger">
                      {{ errorNameCnMessage }}
                    </label>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <!-- customer name en -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name"
                >
                  <b-form-group
                    label="系統帳號名稱："
                    label-for="c_name"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="c_name"
                      v-model="newCustomerData.name"
                      placeholder="輸入系統帳號名稱"
                      :state="getValidationState(validationContext)"
                      @blur="checkUserName"
                    />
                    <label
                      v-if="errorNameMessage && newCustomerData.name"
                      class="text-danger"
                    >
                      {{ errorNameMessage }}
                    </label>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- <b-col cols="12" md="6">
                <b-form-group
                  label="聯絡電話："
                  label-for="phones"
                  label-cols-md="3"
                >
                  <div
                    v-for="(
                      phone, index
                    ) in newCustomerData.phones"
                    :key="index"
                  >
                    <b-input-group class="mb-2">
                      <b-form-input
                        v-model="newCustomerData.phones[index]"
                        placeholder="輸入地址"
                      />
                      <b-input-group-append>
                        <b-button
                          variant="danger"
                          @click="removePhones(index)"
                        >
                          <feather-icon icon="TrashIcon" size="16" />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                  <b-button variant="primary" @click="addPhones" class="mt-1">
                    <feather-icon icon="PlusIcon" size="16" class="mr-1" />
                    添加聯絡電話
                  </b-button>
                </b-form-group>
              </b-col> -->
              <!-- customer tel -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_phone"
                >
                  <b-form-group
                    label="聯絡電話："
                    label-for="c_phone"
                    label-cols-md="3"
                    class="required"
                  >
                    <b-form-input
                      id="c_phone"
                      v-model="newCustomerData.phone"
                      placeholder="輸入聯絡電話"
                      :state="getValidationState(validationContext)"
                      @blur="handlePhoneChange"
                    />
                    <!-- @blur="handlePhoneChange" -->
                    <div v-if="errorPhoneMessage && newCustomerData.phone" >
                      <label class="text-danger">
                        {{ errorPhoneMessage }}
                      </label>
                    </div>
                    <!--<div v-if="newCustomerData.phone" >
                      <label class="text-danger">
                        聯絡電話及備用電話號碼不能一樣
                      </label>
                    </div> -->
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="6">
                  <b-form-group
                    label="禁⽤客⼾原因："
                    label-for="reject_reason"
                    label-cols-md="3"
                  >
                    <b-form-input
                      id="c_phone"
                      v-model="newCustomerData.locked_reason"
                      placeholder="輸入禁⽤客⼾使用系統原因"
                    />
                  </b-form-group>
              </b-col>
              <!-- <b-col cols="12" md="6">
                  <b-form-group
                    label="備用電話號碼："
                    label-for="c_phone2"
                    label-cols-md="3"
                  >
                    <b-form-input
                      id="c_phone"
                      v-model="newCustomerData.phone2"
                      placeholder="輸入備用電話號碼"
                      @blur="checkUserPhone2"
                      :disabled="!ability.can('phone2', 'setting_customer_form')"
                    />
                    disabled="ability.can('create', 'setting-customers-phone') && ability.can('edit', 'setting-customers-phone')"
                    <div v-if="errorPhone2Message && newCustomerData.phone2" >
                      <label class="text-danger">
                        {{ errorPhone2Message }}
                      </label>
                    </div>
                    <div v-if="newCustomerData.phone2 && newCustomerData.phone == newCustomerData.phone2" >
                      <label class="text-danger">
                        聯絡電話及備用電話號碼不能一樣
                      </label>
                    </div>
                  </b-form-group>
              </b-col> -->

              <b-col cols="12">
                <hr />
              </b-col>
              <!-- customer addresses -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="地址："
                  label-for="customer_addresses"
                  label-cols-md="3"
                >
                  <div
                    v-for="(
                      address, index
                    ) in newCustomerData.customer_addresses"
                    :key="index"
                  >
                    <b-input-group class="mb-2">
                      <b-form-input
                        v-model="newCustomerData.customer_addresses[index]"
                        placeholder="輸入地址"
                      />
                      <b-input-group-append>
                        <b-button
                          variant="danger"
                          @click="removeAddress(index)"
                        >
                          <feather-icon icon="TrashIcon" size="16" />
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                  <b-button variant="primary" @click="addAddress" class="mt-1">
                    <feather-icon icon="PlusIcon" size="16" class="mr-1" />
                    添加地址
                  </b-button>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>

              <!-- customer email -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="電郵地址："
                  label-for="c_email"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="c_email"
                    v-model="newCustomerData.email"
                    placeholder="輸入電郵地址"
                    @blur="checkUserEmail"
                  />
                    <label v-if="errorEmailMessage && newCustomerData.email" class="text-danger">
                      {{ errorEmailMessage }}
                    </label>
                </b-form-group>
              </b-col>

              <!-- customer website -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="網址："
                  label-for="c_website"
                  label-cols-md="3"
                >
                  <b-form-input
                    id="c_website"
                    v-model="newCustomerData.website"
                    placeholder="輸入網址"
                  />
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_role_name"
                >
                  <b-form-group
                    label="權限："
                    label-for="role_name"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="role_name"
                      v-model="newCustomerData.role_name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="roleOptions"
                      :clearable="false"
                      :filter="roleSearch"
                      label="name"
                      :reduce="(option) => option.name"
                      placeholder="選擇權限"
                    >
                    </v-select>

                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col> -->

              <b-col cols="12" md="6">
                  <b-form-group
                    label="狀態："
                    label-for="is_active"
                    label-cols-md="3"
                  >
                  <b-form-checkbox
                      style="margin-top: 5px"
                      checked="true"
                      value="1"
                      v-model="newCustomerData.is_active"
                      class="custom-control-success"
                      name="check-button"
                      switch
                      inline
                    />

                    <span style="position: relative; top: -5px">{{
                      newCustomerData.is_active ? "啟用" : "禁用"
                    }}</span>
                  </b-form-group>
              </b-col>

              <b-col cols="12">
                <hr />
              </b-col>
              
            </b-row>
            <b-row class="mt-1" v-if="newCustomerData.id == 0">
              <!-- Field: Password -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="密碼"
                  rules="required|min:8"
                  vid="v_password"
                >
                  <b-form-group
                    class="required"
                    label="密碼"
                    label-for="password"
                    label-cols-md="3"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="password"
                        :type="passwordFieldType"
                        :state="getValidationState(validationContext)"
                        v-model="newCustomerData.password"
                        name="password"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <!-- Field: Password Confirm -->
              <b-col cols="12" md="6" v-if="newCustomerData.id == 0">
                <validation-provider
                  #default="validationContext"
                  name="確認密碼"
                  rules="required|min:8|confirmed:v_password"
                  vid="v_password_confirmation"
                >
                  <b-form-group
                    class="required"
                    label="確認密碼"
                    label-for="password_confirmation"
                    label-cols-md="3"
                  >
                    <b-input-group class="input-group-merge">
                      <b-form-input
                        id="password_confirmation"
                        :type="passwordConfirmFieldType"
                        :state="getValidationState(validationContext)"
                        v-model="newCustomerData.password_confirmation"
                        name="password_confirmation"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordConfirmToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </div>

          <div class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-sm-2 mobile-w100"
              type="submit"
              v-if="(newCustomerData.id > 0 && ability.can('update', 'setting_customers')) || (newCustomerData.id == 0 && ability.can('create', 'setting_customers'))"
            >
              <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
              提交
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
              class="mt-1 mt-sm-0 mobile-w100"
            >
              取消
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch, computed } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email, confirmed, min } from "@validations";
import ability from "@/libs/acl/ability";

export default {
  data() {
    return {
      ability,
      required,
      email,
      confirmed,
      min,
      errorNameCnMessage: null,
      errorNameMessage: null,
      errorPhoneMessage: null,
      errorPhone2Message: null,
      errorEmailMessage: null,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    flatPickr,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BInputGroup,
    BInputGroupAppend,
  },
  methods: {
    changePassword() {
      this.newCustomerData.password = "WFdc_" + this.newCustomerData.phone.toString().slice(-4);
      this.newCustomerData.password_confirmation = "WFdc_" + this.newCustomerData.phone.toString().slice(-4);   
    },
    hide() {
      //localStorage.setItem('activeTab', 0);
      if (this.in_modal) {
        this.$bvModal.hide('modal-customer');
      } else {
        this.$router.replace("/users/list");
      }
    },
    roleSearch(options, search) {
      return options.filter((item) => {
        return item.name.toLowerCase().includes(search.toLowerCase());
      });
    },
    handlePhoneChange(){
      this.changePassword();
      this.checkUserPhone();
    },
    checkUserNameCn() {
      store.dispatch('app/checkUserNameCn', {
        id: this.newCustomerData.id ? this.newCustomerData.id : null,
        name_cn: this.newCustomerData.name_cn
      }).then((response) => {
        this.errorNameCnMessage = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorNameCnMessage = typeof error.response.data.message === 'string' ? error.response.data.message : null;
          }
        });
    },
    checkUserName() {
      store.dispatch('app/checkUserName', {
        id: this.newCustomerData.id ? this.newCustomerData.id : null,
        name: this.newCustomerData.name
      }).then((response) => {
        this.errorNameMessage = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorNameMessage = typeof error.response.data.message === 'string' ? error.response.data.message : null;
          }
        });
    },
    checkUserPhone() {
      store.dispatch('app/checkUserPhone', {
        id: this.newCustomerData.id ? this.newCustomerData.id : null, 
        phone: this.newCustomerData.phone
      }).then((response) => {
        this.errorPhoneMessage = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorPhoneMessage = typeof error.response.data.message === 'string' ? '系統中已有相同電話號碼；請更改電話號碼。' : null;
          }
        });
    },
    checkUserPhone2() {
      store.dispatch('app/checkUserPhone', {
        id: this.newCustomerData.id ? this.newCustomerData.id : null, 
        phone: this.newCustomerData.phone2
      }).then((response) => {
        this.errorPhone2Message = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorPhone2Message = "備用電話已經被使用";
          }
        });
    },
    checkUserEmail() {
      store.dispatch('app/checkUserEmail', {
        id: this.newCustomerData.id ? this.newCustomerData.id : null, 
        email: this.newCustomerData.email
      }).then((response) => {
        this.errorEmailMessage = null;
      })
        .catch((error) => {
          if (error.response.status == 400) {
            this.errorEmailMessage = typeof error.response.data.message === 'string' ? error.response.data.message : null;
          }
        });
    },
    onSubmit() {
      if ( this.errorEmailMessage || this.errorPhoneMessage || this.errorNameCnMessage || this.errorNameMessage){
        return false
      }
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("app/checkUserNameCn", {
              id: this.newCustomerData.id,
              name_cn: this.newCustomerData.name_cn
            })
            .then(() => {
              store
                .dispatch("app/checkUserPhone", {
                  id: this.newCustomerData.id,
                  phone: this.newCustomerData.phone,
                })
              })
            .then(() => {
              if (this.newCustomerData.email) {
                return store.dispatch("app/checkUserEmail", {
                  id: this.newCustomerData.id,
                  email: this.newCustomerData.email,
                });
              }
            })
            .then(() => {
              this.newCustomerData.is_active = this.newCustomerData.is_active ? 1 : 0;
              // 只有在 checkUserPhone 成功後才執行 addCustomer
              return store.dispatch(
                "customer/addCustomer",
                this.newCustomerData
              );
            })
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              if (this.in_modal) {
                // 調用父組件的 fetchOptions 方法
                this.$emit('fetch-options');
                
                // 更新 quotationEditTabInformation 中的 customer_id
                if (response.data && response.data.entity && response.data.entity.id) {
                  this.$emit('update-customer-id', response.data.entity.id);
                } else {
                  console.error('Customer ID not found in response:', response);
                }
              }
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(
                  error.response?.data?.message || error.message
                ),
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
    addAddress() {
      if (!this.newCustomerData.customer_addresses) {
        this.$set(this.newCustomerData, "customer_addresses", []);
      }
      this.newCustomerData.customer_addresses.push("");
    },
    // addPhone() {
    //   if (!this.newCustomerData.phones) {
    //     this.$set(this.newCustomerData, "phones", []);
    //   }
    //   this.newCustomerData.phones.push("");
    // },

    removeAddress(index) {
      this.newCustomerData.customer_addresses.splice(index, 1);
    },
    // removePhone(index) {
    //   this.newCustomerData.phones.splice(index, 1);
    // },
  },
  props: {
    customerData: {
      type: Object,
      required: true,
    },
    roleOptions: {
      type: Array,
      required: true,
    },
    in_modal: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const newCustomerData = ref({
      id: 0,
      is_active: 1,
      customer_addresses: [], // 初始化 customer_addresses
    });

    watch(
      () => props.customerData,
      (newVal) => {
        newCustomerData.value = {
          ...newVal,
          customer_addresses: newVal.customer_addresses || [], // 確保 customer_addresses 存在
        };
      }
    );
    const resetWorkData = () => {
      newCustomerData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          is_active: 1,
        })
      );
    };

    const loading = ref(false);

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetWorkData);

    const passwordFieldType = ref("password");
    const passwordConfirmFieldType = ref("password");

    const togglePasswordVisibility = () => {
      passwordFieldType.value =
        passwordFieldType.value === "password" ? "text" : "password";
      passwordConfirmFieldType.value =
        passwordConfirmFieldType.value === "password" ? "text" : "password";
    };

    const passwordToggleIcon = computed(() =>
      passwordFieldType.value === "password" ? "EyeIcon" : "EyeOffIcon"
    );
    const passwordConfirmToggleIcon = computed(() =>
      passwordConfirmFieldType.value === "password" ? "EyeIcon" : "EyeOffIcon"
    );

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newCustomerData,
      passwordFieldType,
      passwordConfirmFieldType,
      togglePasswordVisibility,
      passwordToggleIcon,
      passwordConfirmToggleIcon,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
</style>

